import '../sass/citrus-timeline.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $citrusTimelines = document.querySelectorAll('.citrus-timeline');

    if (!$citrusTimelines) return;

    $citrusTimelines.forEach($citrusTimeline => {
        const $timeline = $citrusTimeline.querySelector('.citrus-timeline__timeline');
        const $navPrev = $citrusTimeline.querySelector('.citrus-timeline__nav-btn--prev');
        const $navNext = $citrusTimeline.querySelector('.citrus-timeline__nav-btn--next');
        const $markerBar = $citrusTimeline.querySelector('.citrus-timeline__carousel-marker-bar');

        const setMarkerBarPos = (percentage, animate = true) => {
            if (!$markerBar) return;

            if (animate) {
                $markerBar.classList.remove('marker__bar--no-animate');
            }

            if (!animate) {
                $markerBar.classList.add('marker__bar--no-animate');
            }
            
            $markerBar.style.left = `${percentage}%`;
        };

        const initScroller = () => {
            if (!$timeline) return;
            
            const swiperScript = document.querySelector('#citrus-theme-swiper-js');

            if (!swiperScript) return;

            swiperScript.addEventListener('load', () => {
                const carousel = new Swiper($timeline, {
                    slidesPerView: 'auto',
                    navigation: {
                        prevEl: $navPrev,
                        nextEl: $navNext,
                    },
                    speed: noMotionPreference.matches ? 500 : 0,
                    breakpoints: {
                        768: {
                            allowTouchMove: false,
                        }
                    },
                });

                if ($markerBar) {
                    carousel.on('sliderMove', () => {
                        setMarkerBarPos(carousel?.progressLoop * 100, false);
                    });

                    carousel.on('touchEnd', () => {
                        $markerBar.classList.remove('marker__bar--no-animate');

                        setMarkerBarPos(carousel?.realIndex / 
                            (carousel?.slides?.length - (window.innerWidth >= 600 ? 2 : 1)) * 100);
                    });

                    carousel.on('slideChange', () => {
                        setMarkerBarPos(carousel?.realIndex / 
                            (carousel?.slides?.length - (window.innerWidth >= 600 ? 2 : 1)) * 100);
                    });
                }

                window.addEventListener('resize', () => {
                    setMarkerBarPos(carousel?.realIndex / 
                        (carousel?.slides?.length - (window.innerWidth >= 600 ? 2 : 1)) * 100);
                });
            });
        };

        initScroller();
    });
})();
